import { render, staticRenderFns } from "./CardClass.vue?vue&type=template&id=488463e6&"
import script from "./CardClass.vue?vue&type=script&lang=ts&"
export * from "./CardClass.vue?vue&type=script&lang=ts&"
import style0 from "./CardClass.vue?vue&type=style&index=0&id=488463e6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports